<div class="container">
  <div class="formContainer">
    <div>
      <div>
        <h1>{{ labels.VALIDATION_HEADER }}</h1>
        <p>{{ labels.VALIDATION_DESCRIPTION }}</p>
        <h2>{{ labels.VALIDATION_SUB_HEADER }}</h2>

        <form [formGroup]="validationForm">
        <mat-form-field>
          <mat-label>{{ labels.EMPLOYEE_NUMBER }}</mat-label>
          <input matInput formControlName="employeeNo" maxlength="20" />
          <mat-icon matSuffix
                    #tooltip="matTooltip"
                    matTooltip="{{ labels.EMPLOYEE_NUMBER_TOOLTIP }}"
                    matTooltipPosition="above"
                    matTooltipShowDelay="{{ tooltipDelay.SHOW_DELAY }}"
                    matTooltipHideDelay="{{ tooltipDelay.HIDE_DELAY }}"
          >contact_support</mat-icon>
          <mat-error>
            {{ labels.EMPLOYEE_NUMBER_ERROR }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ labels.CARD_NUMBER }}</mat-label>
          <input matInput formControlName="cardNo" maxlength="13" />
          <mat-icon matSuffix
                    #tooltip="matTooltip"
                    matTooltip="{{ labels.CARD_NUMBER_TOOLTIP }}"
                    matTooltipPosition="above"
                    matTooltipShowDelay="{{ tooltipDelay.SHOW_DELAY }}"
                    matTooltipHideDelay="{{ tooltipDelay.HIDE_DELAY }}"
          >contact_support</mat-icon>
          <mat-error>
            {{ labels.CARD_NUMBER_ERROR }}
          </mat-error>
        </mat-form-field>

        <div *ngIf="formError" class="error-message">{{ formErrorMessage }}</div>
        </form>
      </div>

      <div class="buttonContainer">
        <button mat-raised-button color="accent" class="submitButton"
                [disabled]="loading || !validationForm.valid"
                (click)="validateDetails()">
          <mat-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-spinner>
          <span *ngIf="!loading">{{ labels.VALIDATION_SUBMIT }}</span>
        </button>

        <button mat-flat-button (click)="openFAQ.emit()">
          Help and FAQ's
        </button>
      </div>
    </div>
  </div>
  <div class="imageContainer">
    <img matCardImage src="{{ labels.IMAGE }}" />
  </div>
</div>
